import Card from '@precis-digital/kurama/Card'
import { styled } from '@precis-digital/kurama/utils'
import { type ComponentProps, type ReactElement } from 'react'

const StyledBlock = styled(Card)<{ $marginTop?: string }>(({ theme, $marginTop: marginTop }) => ({
  borderRadius: '32px',
  backgroundColor: theme.tokens.background.main.default,
  display: 'flex',
  alignItems: 'start',
  width: '100%',
  flexDirection: 'column',
  marginTop
}))

type BlockProps = Omit<ComponentProps<typeof StyledBlock>, '$marginTop'> & { marginTop?: string }

const Block = ({ marginTop, ...props }: BlockProps): ReactElement => <StyledBlock $marginTop={marginTop} {...props} />

export default Block
